const icons = [
  "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/staff_entertainment_1_0.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/staff_entertainment_1_1.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417971/deals-light-ui/shared/occasions/png/celebration_1_0.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417971/deals-light-ui/shared/occasions/png/celebration_1_1.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417971/deals-light-ui/shared/occasions/png/celebration_2_0.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/celebration_3_0.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/celebration_4_0.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417971/deals-light-ui/shared/occasions/png/celebration_5_0.png",
  "https://res.cloudinary.com/perkbox/image/upload/v1574417970/deals-light-ui/shared/occasions/png/celebration_7_0.png"
]

export default icons
